import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import PaymentDetailService from '../../api/services/PaymentDetailService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import moment from 'moment';
import { downloadExcel } from 'react-export-table-to-excel';
import { Modal, Button } from 'react-bootstrap';

const TodayPickupReturn = () => {
    const [Error, setError] = useState('');
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [PaymentList, setPaymentList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setisloading] = useState(true);
    const tableRef = useRef(null);
    const [packages, setpackages] = useState([]);
    const [cancaletions, setcancaletions] = useState([]);
    const [services, setservices] = useState([]);
    const [accessories, setaccessories] = useState([]);
    const [numberOfNight, setNumberOfNight] = useState([]);
    const [kilometer, setkilometer] = useState([]);
    const [problem_comment, setProblem_comment] = useState(-1)
    const [inputproblem, setInputProblem] = useState('');
    const [general_comment, setgeneral_comment] = useState(-1)
    const [inputgeneral, setInputgeneral] = useState('');
    const [tips_comment, settips_comment] = useState(-1)
    const [inputtip, setInputtip] = useState('');
    const [preparedStatus, setPreparedStatus] = useState({});
    const [UpdateReview, setUpdateReview] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

    const recordsPage = 50000;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = Array.isArray(PaymentList) && PaymentList.length > 0
        ? PaymentList.slice(firstIndex, lastIndex)
        : [];

    const npage = Math.ceil((Array.isArray(PaymentList) ? PaymentList.length : 0) / recordsPage);
    const number = [...Array(npage + 1).keys()].slice(1);
    const navigate = useNavigate();

    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage(id) {
        setCurrentPage(id);
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const currentYear = new Date().getFullYear(); // Get the current year
    // const startYear = currentYear; // 5 years before the current year
    const startYear = Math.min(currentYear, 2024); // Make sure 2024 is included

    const endYear = currentYear + 10; // 5 years after the current year
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
    const [selectedYear, setSelectedYear] = useState('today');

    const userData = JSON.parse(localStorage.getItem("user"));
    const userRole = userData?.roles?.map((data) => {
        return data?.name;
    }) || [];


    const getPaymentList = async () => {

        try {
            let responseData = await PaymentDetailService.indextodaypickupreturn().json()

            setPaymentList(responseData.data)
            setpackages(responseData.packages)
            setcancaletions(responseData.cancaletions)
            setservices(responseData.services)
            setaccessories(responseData.accessories)
            setkilometer(responseData.kilometer)
            setNumberOfNight(responseData.number_of_night);
            // Initialize prepared status from API response
            if (Array.isArray(responseData.data)) {
                const initialPrepared = {};
                responseData.data.forEach((item) => {
                    initialPrepared[item.order_id] = item.is_prepared == 1 ? 1 : 0;
                });
                setPreparedStatus(initialPrepared);
            }
            setisloading(false)
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('admintoken')) {

            getPaymentList();

        }
        else {
            navigate('/');
        }

    }, [])

    useEffect(() => {
        getdashboardByYear();
    }, [startDate])

    const updatechecktatus = async (e) => {
        e.preventDefault();
        let userid = e.target.id
        try {
            var userData = {
                id: userid
            }
            let responseData = await PaymentDetailService.updatechecktatus(userData).json();
            let responseDataOrder = await PaymentDetailService.updateOrderstatus(userid).json();

            if (responseData.status === true || responseDataOrder.status == true) {
                // getPaymentList();
                getdashboardByYear()
            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
  
    const header = [
    "Nr",
    "Vorbereitet",
    "Kaution erhalten",
    "Geprüft?",
    "Typ",
    "Art",
    "Buchungsnummer",
    "Camper-Modell",
    "Kennzeichen",
    "Anzahl Nächte",
    "Versicherungs-Paket",
    "Stornierungsbedingungen",
    "Leistungen",
    "Zubehör",
    "Kilometer",
    "Startdatum",
    "Enddatum",
    "Zahlungsstatus",
    "Vor- & Nachname",
    "E-Mail",
    "Telefonnummer",
    "Geburtsdatum",
    "Straße, Adresszusatz, PLZ",
    "Stadt, Land",
    "USt-IdNr.",
    "Unternehmen",
    "Tipps?",
    "Zufrieden?"
];

const tableData = Array.isArray(PaymentList) && PaymentList.length > 0
    ? PaymentList.map((row, index) => [
        index + 1,
        row.slot_type === "Abholung"
            ? (row.prepared === 0
                ? "Nicht vorbereitet"
                : "Vorbereitet")
            : "",
        row.deposit_received === 0
            ? "Nicht erhalten"
            : "Erhalten",
        row.is_checked == 0
        ? "nicht geprüft"
        : row.is_checked == 1
            ? "Geprüft"
            : row.is_checked == 2
                ? "Ausstehend"
                : "",
        row.camper_type_id === 1
            ? "Rent"
            : row.camper_type_id === 2
                ? "Abonnement"
                : "Verkauf",
        row.slot_type || "",
        row.payment_order_id || "",
        row.camper_name || "",
        row.license_plate || "",
        numberOfNight[index] || "",
        packages[index] || "",
        cancaletions[index] || "",
        services[index] || "",
        accessories[index] || "",
        kilometer[index] || "",
        row.start_date ? moment(row.start_date).format("DD.MM.YYYY HH:mm") : "",
        row.end_date ? moment(row.end_date).format("DD.MM.YYYY HH:mm") : "",
        row.Paid == 1 && row.COD == 0
            ? "Vollständig Bezahlt (Stripe)"
            : row.Paid == 2 && row.COD == 1
                ? "Teilweise bezahlt"
                : row.COD == 1 && row.Paid == 3
                    ? "Vollständig Bezahlt (manuell)"
                    : row.COD == 1 && row.Paid == 0
                        ? "Nicht Bezahlt"
                        : "",
        row.billing_user_name2 || "",
        row.billing_email2 || "",
        row.phone || "",
        row.dob ? moment(row.dob).format("DD.MM.YYYY") : "",
        row.paddress || "",
        row.paddress_2 || "",
        row.pvat_id || "",
        row.pcompany || "",
        row.tips_comment || "",
        row.is_satisfied == 0
            ? "Ja"
            : "Nein"
    ])
    : [];

    const handleProblem_comment = async (id, e, value) => {
        var userData = {}
        if (e === 'Problem_comment') {
            userData = {
                "problem_comment": inputproblem ? inputproblem : value,

            }
            setProblem_comment(-1)
            try {

                let responseData = await PaymentDetailService.updatecomments(id, "problem_comment", userData).json()
                if (responseData.status === true) {
                    alert("update")
                }
                getPaymentList();
            } catch (error) {
                if (error.name === 'HTTPError') {
                    const errorJson = await error.response.json();
                    setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
                }
            }
        }
        else if (e === "General_comment") {
            userData = {

                "general_comment": inputgeneral ? inputgeneral : value,

            }
            setgeneral_comment(-1)
            try {

                let responseData = await PaymentDetailService.updatecomments(id, "general_comment", userData).json()
                if (responseData.status === true) {
                    alert("update")
                }
                getPaymentList();
            } catch (error) {
                if (error.name === 'HTTPError') {
                    const errorJson = await error.response.json();
                    setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
                }
            }
        }
        else if (e === "tips_comment") {
            userData = {

                "tips_comment": inputtip ? inputtip : value,

            }
            settips_comment(-1)
            try {

                let responseData = await PaymentDetailService.updatecomments(id, "tips_comment", userData).json()
                if (responseData.status === true) {
                    alert("aktualisieren")
                }
                getPaymentList();
            } catch (error) {
                if (error.name === 'HTTPError') {
                    const errorJson = await error.response.json();
                    setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
                }
            }
        }



    }

    const handlePrepared = async (orderid) => {

        try {

            let responseData = await PaymentDetailService.updatePrepare(orderid).json()
            if (responseData.status === true) {

                // getPaymentList();
                getdashboardByYear();
            }
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError('Failed to update review. Please try again.')
            }
        }
    }

     const handleKautionempfangen = async (orderid) => {

        try {

            let responseData = await PaymentDetailService.updateKautionempfangen(orderid).json()
            if (responseData.status === true) {

                // getPaymentList();
                getdashboardByYear();
            }
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError('Failed to update review. Please try again.')
            }
        }
    }

    const resetfilter = async () => {
        setisloading(true)
        setSelectedYear('')
        setStartDate(moment().format("YYYY-MM-DD"))
        getPaymentList();
    }

    const handlestartDateChange = (event) => {
        setStartDate(event.target.value);
    };

      function useDownloadExcel() {
        downloadExcel({
            fileName: "Manage Booking",
            sheet: "Manage Booking",
            tablePayload: {
                header,
                body: tableData
            },
        });
    }

    const getdashboardByYear = async (dateValue = startDate, timeRangeValue = selectedYear) => {
        try {
            var payload = {
                "date": dateValue || '',
                "time_range": timeRangeValue || ''
            }
            let responseData = await PaymentDetailService.filterDate(payload).json()

            setPaymentList(responseData.data)
            setpackages(responseData.packages)
            setcancaletions(responseData.cancaletions)
            setservices(responseData.services)
            setaccessories(responseData.accessories)
            setkilometer(responseData.kilometer)
            setNumberOfNight(responseData.number_of_night);
            // setisloading(false)
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    };

    const handleSatisfied = async (orderid, type) => {
    
            try {
                const payload = {
                    status: type
                }
    
                let responseData = await PaymentDetailService.updatesatisfied(orderid, payload).json()
                if (responseData.status === true) {
                    setUpdateReview(true)
               
                    setModalMessage("Der Status „Zufrieden“ wurde erfolgreich aktualisiert.")
                    getdashboardByYear();
                }
                // getPaymentList();
            } catch (error) {
                if (error.name === 'HTTPError') {
                    const errorJson = await error.response.json();
                    setError('Failed to update review. Please try again.')
                }
            }
    }

    return (
        <>
            <MainPagetitle mainTitle="Heute" pageTitle={'Heute'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Abholungen & Rückgaben auf einen Blick</h4>
                                        <button class="btn btn-info btn-sm ms-1 ms-auto" onClick={() => resetfilter(true)}>Filter zurücksetzen</button>
                                        <button onClick={useDownloadExcel} className="btn btn-primary btn-sm ms-1">Als Excel exportieren</button>

                                    </div>

                                  <div
                                        className="d-flex flex-wrap align-items-end gap-3 mb-4 px-3"
                                        style={{ rowGap: "12px" }}
                                    >
                                        <div style={{ minWidth: "220px" }}>
                                            <label className="form-label fw-semibold mb-1">Datum</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="start_date"
                                                value={startDate}
                                                onChange={(e) => {
                                                    handlestartDateChange(e);
                                                    getdashboardByYear(e.target.value, selectedYear);
                                                }
                                                }
                                            />
                                        </div>

                                        <div style={{ minWidth: "160px" }}>
                                            <label className="form-label fw-semibold mb-1">Zeitraum</label>
                                            <select
                                                className="form-control"
                                                name="camper_id"
                                                value={selectedYear}
                                                onChange={(e) => {
                                                    const nextTimeRange = e.target.value;
                                                    setSelectedYear(nextTimeRange);
                                                    getdashboardByYear(startDate, nextTimeRange);
                                                }}
                                            >
                                                {/* <option value="">Bitte wählen Sie aus.</option> */}
                                                    <option key={"today"} value={"today"}>
                                                        Heute  
                                                    </option> 
                                                    <option key={"Week"} value={"week"}>
                                                        Woche 
                                                    </option>
                                                    {userRole.includes("Admin") && (
                                                        <>
                                                        <option value="month">Month</option>
                                                        <option value="year">Year</option>
                                                        </>
                                                    )}
                                            </select>
                                        </div>

                                        {/* <div className="d-flex gap-2 ms-auto">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm"
                                                onClick={() => setFilterModal(true)}
                                            >
                                                Filter
                                            </button>

                                            <button
                                                type="button"
                                                className="btn btn-info btn-sm"
                                                onClick={() => resetfilter(true)}
                                            >
                                                Reset
                                            </button>
                                        </div> */}
                                    </div>

                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0" ref={tableRef}>
                                            <thead>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th><strong>Nr.</strong></th>
                                                    <th>
                                                        <strong>Vorbereitet</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Kaution Erhalten?</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Geprüft?</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Typ</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Art</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Buchungsnummer</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Camper-Modell</strong>
                                                    </th>
                                                     <th>
                                                        <strong>Kennzeichen</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Anzahl Nächte</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Versicherungs-Paket</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Stornierungsbedingungen</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Leistungen</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Zubehör</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Kilometer</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Startdatum</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Enddatum</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Zahlungsstatus</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Vor- & Nachname</strong>
                                                    </th>
                                                    <th>
                                                        <strong>E-Mail</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Telefonnummer</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Geburtsdatum</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Straße, Adresszusatz, PLZ</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Stadt, Land</strong>
                                                    </th>
                                                    <th>
                                                        <strong>USt-IdNr.</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Unternehmen</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Tipps?</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Zufrieden?</strong>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    records.length > 0 ? (
                                                        records.map((element, index) => {

                                                            return (
                                                                <tr style={{ textAlign: 'center' }}>

                                                                    <td>
                                                                        <div className="products">
                                                                            <h6>{index + 1}</h6>
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        {element.slot_type == "Abholung" ? (
                                                                            element.prepared == 0 ?
                                                                                <span className="btn btn-danger btn-sm ms-1" onClick={() => handlePrepared(element.order_id)}>Nicht vorbereitet</span> :
                                                                                <span className="btn btn-success btn-sm ms-1" onClick={() => handlePrepared(element.order_id)}>Vorbereitet</span>
                                                                        ) :""}
                                                                        
                                                                    </td>

                                                                    <td>
                                                                        {element.deposit_received == 0 ?
                                                                            <span className="btn btn-danger btn-sm ms-1" onClick={() => handleKautionempfangen(element.order_id)}>nicht Empfangen</span> :
                                                                            <span className="btn btn-success btn-sm ms-1" onClick={() => handleKautionempfangen(element.order_id)}>Empfangen</span>}
                                                                        
                                                                    </td>
                    
                                                                          <td>
                                                                        {/* {element.is_checked == 0 || element.ischecked == 1 ?  */}
                                                                        {element.is_checked == 0 ?
                                                                            <span className="btn btn-danger btn-sm ms-1">nicht geprüft</span>
                                                                            : element.is_checked == 1 ?
                                                                                <span className="btn btn-success btn-sm ms-1">Geprüft</span>
                                                                                : element.is_checked == 2 ?
                                                                                    <span className="btn btn-warning btn-sm ms-1">Ausstehend</span> : ''}
                                                                        {userRole.includes("Admin") && ( <Link id={element.order_id} onClick={updatechecktatus}> Ändern?</Link>)}            
                                                                    </td>
                                                                  
                                                                    <td style={{ color: '#3AC977' }}>{element.camper_type_id === 1 ? "Rent" : element.camper_type_id === 2 ? "Abonnement" : "Verkauf"}</td>
                                                                    <td>{element.slot_type}</td>
                                                                    <td>{element.payment_order_id}</td>
                                                                    <td>{element.camper_name}</td>
                                                                    <td>{element.license_plate}</td>
                                                                    <td>{numberOfNight[index]}</td>
                                                                    <td style={{ whiteSpace: 'pre-line' }}>{packages[index]}</td>
                                                                    <td style={{ whiteSpace: 'pre-line' }}>{cancaletions[index]}</td>
                                                                    <td style={{ whiteSpace: 'pre-line' }}>{services[index]}</td>
                                                                    <td style={{ whiteSpace: 'pre-line' }}>{accessories[index]}</td>
                                                                    <td style={{ whiteSpace: 'pre-line' }}>{kilometer[index]}</td>

                                                                    <td>{moment(element.start_date).format('DD.MM.YYYY HH:mm')}</td>
                                                                    <td>{moment(element.end_date).format('DD.MM.YYYY HH:mm')}</td>
                                                                    <td>
                                                                        {
                                                                            element.Paid == 1 && element.COD == 0 ?
                                                                                <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#006400", color: "#fff" }}>Vollständig Bezahlt (Stripe)</span>
                                                                                :
                                                                                element.Paid == 2 && element.COD == 1 ?
                                                                                    <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#FFA500", color: "#fff" }}>Teilweise bezahlt</span>
                                                                                    :
                                                                                    element.COD == 1 && element.Paid == 3 ?
                                                                                        <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#32CD32", color: "#fff" }}>Vollständig Bezahlt (manuell)</span>
                                                                                        :
                                                                                        element.COD == 1 && element.Paid == 0 ?
                                                                                            <span className="btn btn-sm ms-1" style={{ backgroundColor: "#FF0000", color: "#fff" }}>Nicht Bezahlt</span> :
                                                                                            ""
                                                                        }
                                                                        {/* {element.Paid == 1 && element.COD == 0 ? "" : <Link id={element.payment_id}
                                                                            onClick={handlePaidStatus}> Change?</Link>} */}
                                                                    </td>
                                                                    {/* <td>{
                                                                        element.Paid == 1 && element.COD == 0 ?
                                                                            <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#006400", color: "#fff" }}>Fully Paid  (Stripe)</span>
                                                                            :  element.Paid == 0 ?
                                                                                <span className="btn btn-sm ms-1" style={{ backgroundColor: "#FF0000", color: "#fff" }}>Not Paid</span> :
                                                                                 element.Paid == 2 ?
                                                                                    <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#FFA500", color: "#fff" }}>Partially Paid</span>
                                                                                    :
                                                                                    element.Paid == 3 ?
                                                                                        <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#32CD32", color: "#fff" }}>Fully Paid (Manual)</span>
                                                                                        : element.COD == 1 ?
                                                                                            <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#32CD32", color: "#fff" }}>Fully Paid (Manual)</span> : ""
                                                                    }
                                                                        {element.Paid == 1 && element.COD == 0 ? "" : <Link id={element.payment_id}
                                                                            onClick={handlePaidStatus}> Change?</Link>}
                                                                    </td> */}
                                                                    <td>{element.billing_user_name2}</td>
                                                                    <td>{element.billing_email2}</td>
                                                                    <td>{element.phone}</td>
                                                                    <td>{moment(element.dob).format('DD.MM.YYYY')}</td>

                                                                    <td>{element.paddress}</td>
                                                                    <td>{element.paddress_2}</td>
                                                                    <td>{element.pvat_id}</td>
                                                                    <td>{element.pcompany}</td>
                                                            
                                                                    <td>
                                                                        {tips_comment == index ? (
                                                                            <>
                                                                                <input name="tips_comment"
                                                                                    defaultValue={element.tips_comment} onChange={(e) => setInputtip(e.target.value)} />
                                                                                <button className="btn btn-success btn-sm ms-1" onClick={() => {
                                                                                    handleProblem_comment(element.order_id, "tips_comment", element.tips_comment)

                                                                                }
                                                                                }>Speichern</button>

                                                                            </>

                                                                        ) : (
                                                                            <div>
                                                                                <p>{element.tips_comment}</p>
                                                                                <button className="btn btn-success btn-sm ms-1" onClick={() => {

                                                                                    settips_comment(index)
                                                                                }
                                                                                }>Bearbeiten</button>
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            element.is_satisfied == 0 ?
                                                                                <span className="btn btn-success btn-sm ms-1" onClick={() => handleSatisfied(element.order_id, 1)}>Ja</span>
                                                                                :

                                                                                <span className="btn btn-brown btn-sm ms-1" onClick={() => handleSatisfied(element.order_id, 0)}>Nein</span>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr style={{ textAlign: 'center' }}>

                                                            <td colSpan={12}>
                                                                <div className='text-center'>No records found</div>
                                                            </td>
                                                        </tr>

                                                    )
                                                }

                                            </tbody>

                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Zeigt {lastIndex - recordsPage + 1} Zu{" "}
                                                {Array.isArray(PaymentList) && PaymentList.length < lastIndex ? PaymentList.length : lastIndex}
                                                {" "}von {Array.isArray(PaymentList) ? PaymentList.length : 0} einträge
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal centered className="mark-attendence" show={UpdateReview}>
                <Modal.Header>
                    <Modal.Title>Saved </Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setUpdateReview(false)}></Button>
                </Modal.Header>
                <Modal.Body>{modalMessage}</Modal.Body>
                <Modal.Footer>
                    <Link className="btn btn-primary" variant="danger light" onClick={() => setUpdateReview(false)}>Close</Link>
                </Modal.Footer>
            </Modal>

            {isLoading && <LogoAnimationLoader />}

        </>
    );
};

export default TodayPickupReturn;
